(function () {
  "use strict";

  /* Shared store lives in lp-wishlist.js (window.LPWishlist), loaded globally. */
  function wl() { return window.LPWishlist; }

  function initHearts(sectionEl) {
    var hearts = sectionEl.querySelectorAll("[data-pg-heart]");
    if (!hearts.length || !wl()) return;

    function reflect() {
      sectionEl.querySelectorAll("[data-pg-heart]").forEach(function (btn) {
        var card = btn.closest(".pg-card__inner");
        var id = card && card.getAttribute("data-product-id");
        if (id) btn.setAttribute("aria-pressed", wl().has(id) ? "true" : "false");
      });
    }
    reflect();
    if (!sectionEl.dataset.pgHeartSub) {
      sectionEl.dataset.pgHeartSub = "1";
      document.addEventListener("lp:wishlist:change", reflect);
    }

    hearts.forEach(function (btn) {
      if (btn.dataset.pgHeartBound) return;
      btn.dataset.pgHeartBound = "1";
      var card = btn.closest(".pg-card__inner");
      var productId = card ? card.getAttribute("data-product-id") : null;
      if (!productId) return;

      btn.addEventListener("click", function () {
        var next = wl().toggle(productId, wl().meta(btn));
        btn.setAttribute("aria-pressed", String(next));

        btn.animate(
          [
            { transform: "scale(1)" },
            { transform: "scale(0.82)" },
            { transform: "scale(1.08)" },
            { transform: "scale(1)" },
          ],
          { duration: 320, easing: "ease" }
        );
      });
    });
  }

  function initLoadMore(sectionEl) {
    var grid = sectionEl.querySelector("[data-pg-grid]");
    var btn = sectionEl.querySelector("[data-pg-more]");
    if (!grid || !btn) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(".pg-card"));
    var visible = parseInt(grid.getAttribute("data-visible"), 10) || cards.length;
    var step = parseInt(grid.getAttribute("data-step"), 10) || cards.length;

    function sync() {
      cards.forEach(function (card, i) {
        card.hidden = i >= visible;
      });
      btn.hidden = visible >= cards.length;
    }

    btn.addEventListener("click", function () {
      var firstNewIndex = visible;
      visible = Math.min(visible + step, cards.length);
      sync();
      var focusTarget = cards[firstNewIndex];
      if (focusTarget) {
        var link = focusTarget.querySelector("a");
        if (link) link.focus({ preventScroll: true });
      }
    });

    sync();
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    initHearts(sectionEl);
    initLoadMore(sectionEl);
  }

  function init() {
    document.querySelectorAll(".product-grid").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target || !e.target.querySelector) return;
    initSection(e.target.querySelector(".product-grid"));
  });
})();
